export { default, default as Tag } from './Tag'
export { default as tagTheme } from './themes/Tag.theme'
export * as TagStyles from './styles/Tag.style'

export type { TagProps } from './Tag.types'
export type { AppearanceKeys, TagTheme } from './themes/Tag.theme.types'
export type { StyledTagProps } from './styles/Tag.style.types'
